import { Datagrid, List, TextField } from 'react-admin';

export const AgencyList = () => (
    <List perPage={25}>
        <Datagrid rowClick="edit">
            <TextField source="name" />
            <TextField source="domain" />
        </Datagrid>
    </List>
);

export default AgencyList;
